import type { ApiOrganizationSettingsData } from "types/api"

export default class OrganizationSetting {
    billing_email: string | null

    constructor(data: ApiOrganizationSettingsData) {
        this.billing_email = data.billing_email
    }
}
